import { BehaviorSubject, Subject } from 'rxjs';

export class RemoteMediaEventBus {
  static handleVideoPrivacy$ = new BehaviorSubject<string>('');

  // Emits when remote video should be reset
  static resetRemoteVideo$ = new Subject<void>();
}
